<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranIdStranka="GetStranka" :selectorPermissions="selectorPermission" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine" v-loading="nalaganjeDirektorijev">
        <p class="open-sans-30pt">
          Spletna predstavitev
        </p>
        <div v-if="seznamNosilnihPrikljuckov.length > 1" style="padding-top: 20px; padding-bottom: 15px">
          <p>
            Izberite priključek
            <el-select v-model="izbranPrikljucek" value-key="id_prikljucek" class="izbirnik-prikljuckov">
              <el-option v-for="(data) in seznamNosilnihPrikljuckov"
                         :value="data.id_prikljucek"
                         :label="`${data.naslov}`"
                         :key="data.id_prikljucek">
              </el-option>
            </el-select>
          </p>
        </div>
        <div v-if="statusKreiranjaSpletne === 0 && kreiranDirektorij.length === 0  && !nalaganjeDirektorijev">
          <div>
            <p class="navadno-besedilo odmik-od-naslova">
              Spletna predstavitev je namenjena preprosti osebni predstavitvi T2 uporabnikov. <br/>
              Vsakemu naročniku pripada 100 MB prostora, na katerega lahko naložite preprosto
              spletno stran.
            </p>
          </div>
          <div style="padding-top: 30px">
            <el-button type="primary" class="gumb-potrdi" @click="KreiranjeSpletnePredstavitve">
              USTVARI SVOJO SPLETNO PREDSTAVITEV
            </el-button>
          </div>
          <div style="padding-top: 60px">
            <hr class="hr-stil"/>
          </div>
          <div>
            <VsebinaZacetnaStran/>
          </div>
        </div>
        <div v-if="statusKreiranjaSpletne === 1 && !nalaganjeDirektorijev">
          <p class="navadno-besedilo" style="padding-top: 15px">
            FeeWeb je namenjen preprosti osebni predstavitvi. Vsakemu naročniku pripada 50 MB prostora,
            na katerega lahko naložite preprosto spletno stran.
          </p>
          <p class="navadno-besedilo">
            <b>
              Že kreiranega direktorija za brezplačno spletno predstavitev se po protokolu ne da spreminjati.
            </b>
          </p>
          <div style="padding-top: 30px;">
            <p class="open-sans-20pt">
              Nova mapa
            </p>
          </div>
          <div class="postavitev-forme">
            <el-form label-width="160px" :label-position="formaOrientacija" autocomplete="off" class="custom-labels">
              <el-form-item label="Naziv mape:" style="color: #080809; ">
                <el-input placeholder="Vnesite ime direktorija" v-model="imeDirektorija"
                          @change="PreverjanjeImenaDirektorija(imeDirektorija)"
                          class="pozicija-ime-direktorija"/>
                <span class="mapa-label">
                <i class="el-icon-warning open-sans-10pt">
                  <small>
                    Pomembno: naziv mape je del URL vaše predstavitve in ga ni možno spremeniti kasneje.
                  </small>
                </i>
                </span>
              </el-form-item>
              <el-form-item label="Uporabniško ime:">
                <el-input placeholder="Vnesite uporabniško ime" v-model="uporabniskoIme"
                          @change="PreverjanjeUporabniskegaImena(uporabniskoIme)"
                          class="pozicija-uporabnisko-ime">
                </el-input>
              </el-form-item>
              <el-form-item label="Geslo:" style="label: none;">
                <el-input placeholder="Vnesite novo geslo" type="password" v-model="geslo" autocomplete="off"
                          class="pozicija-novo-geslo" value="FakePSW" id="input-novo-geslo">
                  <i slot="suffix" class="fa fa-eye-slash ikonaEyeSlashNovoGeslo"
                     @click="PrikazGesel('input-novo-geslo')" v-if="prikazeIkonoNovoGeslo">
                  </i>
                  <i slot="suffix" class="fa fa-eye ikonaEyeNovoGeslo"
                     @click="PrikazGesel('input-novo-geslo')" v-else>
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item label="Ponovitev gesla:" style="max-height: 360px;">
                <el-input placeholder="Ponovno vnesite novo geslo" type="password" autocomplete="off"
                          v-model="ponovljenoGeslo"
                          class="pozicija-potrjeno-geslo" value="FakePSW" id="input-ponovite-geslo">
                  <i slot="suffix" class="fa fa-eye-slash ikonaEyeSlashPonoviteGeslo"
                     @click="PrikazGesel('input-ponovite-geslo')" v-if="prikazeIkonoPonoviteGeslo">
                  </i>
                  <i slot="suffix" class="fa fa-eye ikonaEyePonoviteGeslo"
                     @click="PrikazGesel('input-ponovite-geslo')" v-else>
                  </i>
                </el-input>
                <validacija-vrednosti
                   v-if="!statusValidacije"
                  :prva-vrednost="geslo"
                  :druga-vrednost="ponovljenoGeslo"
                  :style=" ponovljenoGeslo ? 'margin-top:0':'margin-top:-45px'"
                   v-on:ValidacijaStatus="SpremeniStatus"/>
              </el-form-item>
            </el-form>
          </div>
          <div class="odmik-gumbov-forme" style="clear: both">
            <el-button type="primary" @click="KreiranjeSpletnegaDirektorija"
                       class="gumb-potrdi gumb-potrdi-sirina"
                       :disabled="!(uporabniskoIme && imeDirektorija && statusValidacije)">
              USTVARI NOVO MAPO
            </el-button>
            <span class="odmik-gumba-preklici">
              <a class="stil-gumb-preklici" @click="PreklicKreiranjaSpletnegaDirektorija">
                Prekliči
              </a>
            </span>
          </div>
          <div style="clear: both"/>
        </div>
        <div style="clear: both" v-if="kreiranDirektorij.length > 0 && !nalaganjeDirektorijev">
          <div>
              <p class="navadno-besedilo odmik-od-naslova">
                Spletna predstavitev je namenjena preprosti osebni predstavitvi T2 uporabnikov.
                <br/>
                Vsakemu naročniku pripada 100 MB prostora, na katerega lahko naložite preprosto
                spletno stran.
              </p>
          </div>
          <div v-if="kreiranDirektorij.length > 0" v-loading="nalaganjeDirektorijev">
            <div class="odmiki-spletna-predstavitev"  id="nastavitev-gesla-spletna-predstavitev">
              <p class="open-sans-20pt">
                Moje mape
              </p>
            </div>
            <el-table :data="kreiranDirektorij"
                      v-loading="nalaganjeDirektorijev"
                      :expand-row-keys="expandRowKeys"
                      :row-key="row => row.direktorij"
                      @expand-change="Izbranavrstica">
              <el-table-column label="Ime mape">
                <template slot-scope="scope">
                  {{ scope.row.direktorij }}
                </template>
              </el-table-column>
              <el-table-column label="Spletni naslov" v-if="this.formaOrientacija !== 'top'">
                <template slot-scope="scope">
                  <a class="primarna-barva" :href="scope.row.url">
                    {{ scope.row.url }}
                  </a>
                </template>
              </el-table-column>
              <el-table-column label="Prostor na strežniku" v-if="this.formaOrientacija !== 'top'">
                <template slot-scope="scope">
                  {{ scope.row.pretvorbaProstora }}
                </template>
              </el-table-column>
              <el-table-column label="Datum kreiranja" :width="velikostDatumKreiranja">
                <template slot-scope="scope">
                  {{ scope.row.datum }}
                </template>
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <div class="notranji-odmik">
                    <div class="postavitev-podatkov">
                      <div class="notranja-postavitev">
                        <div>
                          <p>
                            Ime mape:
                            <b>
                              {{ scope.row.direktorij }}
                            </b>
                            <br/>
                            Spletni naslov:
                            <b>
                              {{ scope.row.url }}
                            </b>
                            <br/>
                            Prostor na strežniku:
                            <b>
                              {{ scope.row.pretvorbaProstora }}
                            </b>
                          </p>
                        </div>
                        <div style="padding-top: 10px">
                          <p>
                            FTP dostop:
                            <b>
                              {{ scope.row.ftp }}
                            </b>
                            <br/>
                            Uporabniško ime:
                            <b>
                              {{ scope.row.uporabnik }}
                            </b>
                          </p>
                        </div>
                        <div class="stil-postavitev-gumbov">
                          <el-form label-width="160px" :label-position="formaOrientacija"
                                   v-loading="spremembaGesla" class="nova-vrstica-forma">
                            <el-form-item label="Geslo:" style="label: none;">
                              <el-input placeholder="Vnesite novo geslo" type="password"
                                        v-model="gesloForma"
                                        class="pozicija-novo-geslo" value="FakePSW"
                                        id="input-novo-geslo-sprememba">
                                <i slot="suffix"
                                   class="fa fa-eye-slash ikonaEyeSlashNovoGeslo"
                                   @click="PrikazGesel('input-novo-geslo-sprememba')"
                                   v-if="prikazeIkonoNovoGesloForma">
                                </i>
                                <i slot="suffix" class="fa fa-eye ikonaEyeNovoGeslo"
                                   @click="PrikazGesel('input-novo-geslo-sprememba')"
                                   v-else>
                                </i>
                              </el-input>
                            </el-form-item>
                            <el-form-item label="Ponovitev gesla:">
                              <el-input placeholder="Ponovno vnesite novo geslo"
                                        type="password"
                                        v-model="gesloFormaPonovljeno"
                                        class="pozicija-potrjeno-geslo" value="FakePSW"
                                        id="input-ponovite-geslo-sprememba">
                                <i slot="suffix"
                                   class="fa fa-eye-slash
                                                                    ikonaEyeSlashPonoviteGeslo"
                                   @click="PrikazGesel('input-ponovite-geslo-sprememba')"
                                   v-if="prikazeIkonoPonoviteGesloForma">
                                </i>
                                <i slot="suffix"
                                   class="fa fa-eye ikonaEyePonoviteGeslo"
                                   @click="PrikazGesel('input-ponovite-geslo-sprememba')"
                                   v-else>
                                </i>
                              </el-input>
                              <validacija-vrednosti
                                class="mobile-pozicija"
                                :prva-vrednost="gesloForma"
                                :druga-vrednost="gesloFormaPonovljeno"
                                :style="gesloFormaPonovljeno ? 'margin-top:0':'margin-top:-45px; z-index: 1'" />
                            </el-form-item>
                          </el-form>
                          <div style="padding-top: 30px">
                            <el-button class="gumb-potrdi gumb-sirina-sprememba-gesla"
                                       @click="MenjavaGesla(scope.row.direktorij)">
                              SPREMENI GESLO
                            </el-button>
                          </div>
                        </div>
                      </div>
                      <div class="vsebina-za-odstranitev-mape">
                        <div class="odmik-odstrani-mapo">
                          <div>
                            <div style="float: left">
                              <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                            </div>
                          </div>
                          <div style="padding-left: 20px; padding-top: 2px">
                            <div>
                              <a @click="OdstraniDirektorij(scope.row.direktorij)" class="stil-odstrani-mapo">
                                ODSTRANI MAPO
                              </a>
                            </div>
                          </div>
                        </div>
                        <div style="clear: both">
                          <div>
                            <div style="padding-top: 20px">
                              <p>
                                <b class="primarna-barva-pisave">
                                  POZOR:
                                </b>
                              </p>
                              <p class="navadno-besedilo">
                                Če odstranite mapo, bodo izbrisani tudi vsi podatki, ki
                                se nahajajo v njej. Priporočamo, da pred odstranitvijo
                                ustvarite varnostno kopijo.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div/>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import IzbirnikPrikljuckov from '../GlobalneKomponente/IzbirnikPrikljuckov'
import VsebinaZacetnaStran from '../Nastavitve/SpletnaPredstavitev/VsebinaZacetnaStran.vue'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {PretvorbaEnot} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PretvorbaEnotB.js'
import {Input, Button, Select, Option, Row, Collapse, CollapseItem, Tooltip, MessageBox} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import ValidacijaVrednosti from '../Mojprofil/Varnost/ValidacijaVrednosti'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'

export default {
  name: 'SpletnaPredstavitev',
  mixins: [PretvorbaEnot, SirinaOkna],
  data () {
    return {
      clientAgent: null,
      imeDirektorija: '',
      uporabniskoIme: '',
      geslo: '',
      ponovljenoGeslo: '',
      gesloForma: '',
      gesloFormaPonovljeno: '',
      formaOrientacija: 'left',
      spremembaGesla: false,
      mejnaSirina: 1300,
      nalaganjeDirektorijev: true,
      prikazeIkonoPonoviteGeslo: true,
      prikazeIkonoNovoGeslo: true,
      prikazeIkonoNovoGesloForma: true,
      prikazeIkonoPonoviteGesloForma: true,
      kreiranDirektorij: [],
      expandRowKeys: [],
      izbranPrikljucek: null,
      statusKreiranjaSpletne: 0,
      velikostDatumKreiranja: '230',
      statusValidacije: false,
      selectorPermission: ['STRANKE'],
      seznamNosilnihPrikljuckov: [],
      pridobivanjePodatkov: true
    }
  },
  watch: {
    orientacija (val) {
      this.formaOrientacija = val
    },
    formaOrientacija () {
      if (this.formaOrientacija === 'top') {
        this.velikostDatumKreiranja = '130'
      } else {
        this.velikostDatumKreiranja = '230'
      }
    },
    izbranPrikljucek () {
      this.GetUporabniskihPodatkov()
      this.statusKreiranjaSpletne = 0
    }
  },
  components: {
    IzbirnikStranke,
    'ValidacijaVrednosti': ValidacijaVrednosti,
    'VsebinaZacetnaStran': VsebinaZacetnaStran,
    'IzbirnikPrikljuckov': IzbirnikPrikljuckov,
    [Option.name]: Option,
    [Select.name]: Select,
    [Button.name]: Button,
    [Input.name]: Input,
    [Row.name]: Row,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tooltip.name]: Tooltip
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStranka = podatkiStranke
        this.GetPrikljuckiDovoljenja(podatkiStranke)
      }
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.idStrank = prenosniParamIdStranka
        let param = ['permissionId=PRIKLJUCKI']
        param.push('filter[tip_prikljucka]=FIX')
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamNosilnihPrikljuckov = []
      this.seznamPrikljuckov = []
      this.izbranPrikljucek = null
      this.seznamPrikljuckov = podatki.permission.additionalData
      for (let i = 0; i < this.seznamPrikljuckov.length; i++) {
        if (this.seznamPrikljuckov[i].id_stranka === this.izbranaStranka) {
          this.seznamNosilnihPrikljuckov.push(this.seznamPrikljuckov[i])
          this.izbranPrikljucek = this.seznamNosilnihPrikljuckov[0].id_prikljucek
        }
      }
      this.GetUporabniskihPodatkov()
      this.FormatVpisanihPodatkov()
      this.FormatPrikazaGesla()
      this.statusKreiranjaSpletne = 1
      this.pridobivanjePodatkov = false
    },
    ErrPrikljuckiDovoljenja (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SpremeniStatus (e) {
      this.statusValidacije = e
    },
    KreiranjeSpletnePredstavitve () {
      this.statusKreiranjaSpletne = 1
    },
    PreklicKreiranjaSpletnegaDirektorija () {
      this.statusKreiranjaSpletne = 0
      this.FormatVpisanihPodatkov()
    },
    Izbranavrstica (row) {
      const id = row.direktorij
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]

      this.FormatPrikazaGesla()
    },
    PrikazGesel (id) {
      let element = document.getElementById(id)
      if (element.type === 'password') {
        element.type = 'text'
        if (id === 'input-novo-geslo' || id === 'input-novo-geslo-sprememba' || id === 'input-novo-geslo-tabela') {
          this.prikazeIkonoNovoGeslo = false
          this.prikazeIkonoNovoGesloForma = false
        } else {
          this.prikazeIkonoPonoviteGeslo = false
          this.prikazeIkonoPonoviteGesloForma = false
        }
      } else {
        element.type = 'password'
        if (id === 'input-novo-geslo' || id === 'input-novo-geslo-sprememba' || id === 'input-novo-geslo-tabela') {
          this.prikazeIkonoNovoGeslo = true
          this.prikazeIkonoNovoGesloForma = true
        } else {
          this.prikazeIkonoPonoviteGeslo = true
          this.prikazeIkonoPonoviteGesloForma = true
        }
      }
    },
    GetUporabniskihPodatkov () {
      if (this.izbranPrikljucek !== null) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/freeweb/info?',
          param,
          null,
          'SetUporabniskihPodatkov',
          'ErrUporabniskihPodatkov')
      } else {
        this.nalaganjeDirektorijev = false
        this.kreiranDirektorij = []
      }
    },
    SetUporabniskihPodatkov (podatki) {
      this.kreiranDirektorij = []
      if (podatki.data.length !== 0) {
        this.statusKreiranjaSpletne = 0
        this.kreiranDirektorij = podatki.data
        for (let i = 0; i < this.kreiranDirektorij.length; i++) {
          let pretvorbaZasedenostiProstora = 0
          pretvorbaZasedenostiProstora = this.PretvoriKolicinoVPrijaznoOblikoB(this.kreiranDirektorij[i].prostor)
          this.pretvorbaProstora = pretvorbaZasedenostiProstora
          Vue.set(this.kreiranDirektorij[i], 'pretvorbaProstora', this.pretvorbaProstora)
        }
        if (this.kreiranDirektorij.length === 1) {
          this.expandRowKeys = [this.kreiranDirektorij[0].direktorij]
        } else {
          this.expandRowKeys = []
        }
      }
      this.nalaganjeDirektorijev = false
    },
    ErrUporabniskihPodatkov (podatki) {
      this.nalaganjeDirektorijev = false
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    FormatPrikazaGesla () {
      this.prikazeIkonoNovoGeslo = true
      this.prikazeIkonoNovoGesloForma = true
      this.prikazeIkonoPonoviteGeslo = true
      this.prikazeIkonoPonoviteGesloForma = true
    },
    FormatVpisanihPodatkov () {
      this.uporabniskoIme = ''
      this.imeDirektorija = ''
      this.geslo = ''
      this.ponovljenoGeslo = ''
    },
    PreverjanjeUporabniskegaImena (prenosniParam) {
      this.preverjanjeuporabniskegaImena = false
      let param = ['uporabniskoIme=' + prenosniParam]
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/freeweb/preveriUporabniskoIme?',
        param,
        null,
        'SetPreverjanjeUporabniskegaImena',
        'ErrPreverjanjeUporabniskegaImen')
    },
    SetPreverjanjeUporabniskegaImena () {
      this.preverjanjeuporabniskegaImena = true
    },
    ErrPreverjanjeUporabniskegaImen (podatki) {
      this.preverjanjeuporabniskegaImena = false
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    PreverjanjeImenaDirektorija (prenosniParam) {
      this.preverjanjeImenaDirektorija = false
      let param = ['direktorij=' + prenosniParam]
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/freeweb/preveriDirektorij?',
        param,
        null,
        'SetPreverjanjeImenaDirektorija',
        'ErrPreverjanjeImenaDirektorija')
    },
    SetPreverjanjeImenaDirektorija () {
      this.preverjanjeImenaDirektorija = true
    },
    ErrPreverjanjeImenaDirektorija (podatki) {
      this.preverjanjeImenaDirektorija = false
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    KreiranjeSpletnegaDirektorija () {
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      if (this.preverjanjeuporabniskegaImena === true) {
        param.push('uporabniskoIme=' + this.uporabniskoIme)
      }
      if (this.preverjanjeImenaDirektorija === true) {
        param.push('direktorij=' + this.imeDirektorija)
      }
      param.push('geslo1=' + this.geslo)
      param.push('geslo2=' + this.ponovljenoGeslo)
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/freeweb/kreirajRacun?',
        param,
        null,
        'SetKreiranegaDirektorija',
        'ErrKreiranegaDirektorija')
    },
    SetKreiranegaDirektorija () {
      this.FormatVpisanihPodatkov()
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno ste ustvarili spletni direktorij za vašo spletno stran.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetUporabniskihPodatkov()
      this.FormatPrikazaGesla()
    },
    ErrKreiranegaDirektorija (podatki) {
      let paramObvestilo = {}
      if (this.preverjanjeImenaDirektorija === false) {
        paramObvestilo.message = 'Vpisano ime direktorija spletne strani ni pravilno.'
      } else if (this.preverjanjeuporabniskegaImena === false) {
        paramObvestilo.message = 'Uporabniško ime ni pravilno. Prosimo, poskusite ponovno.'
      } else {
        paramObvestilo.message = podatki.message
      }
      this.ShowWarningMessage(paramObvestilo)
    },
    MenjavaGesla (prenosniDirektorij) {
      this.spremembaGesla = true
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      param.push('geslo1=' + this.gesloForma)
      param.push('geslo2=' + this.gesloFormaPonovljeno)
      param.push('direktorij=' + prenosniDirektorij)
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/freeweb/spremeniGeslo',
        param,
        null,
        'SetMenjavaGesla',
        'ErrMenjavaGesla')
    },
    SetMenjavaGesla () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Vaše geslo je uspešno spremenjeno.'
      this.ShowSuccessMessage(paramObvestilo)
      this.FormatGesla()
      this.GetUporabniskihPodatkov()
      this.spremembaGesla = false
    },
    ErrMenjavaGesla (podatki) {
      this.ShowWarningMessage(podatki)
      this.spremembaGesla = false
    },
    FormatGesla () {
      this.gesloForma = ''
      this.gesloFormaPonovljeno = ''
    },
    OdstraniDirektorij (prenosniDirektorij) {
      MessageBox.confirm('Ste prepričani, da želite odstraniti spletno stran z mapo ' + prenosniDirektorij + '?'
        , {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('direktorij=' + prenosniDirektorij)
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/freeweb/izbrisiRacun?',
          param,
          null,
          'SetOdstraniDirektorij',
          'ErrOdstraniDirektorij')
      }).catch((err) => {
        err = null
      })
    },
    SetOdstraniDirektorij () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Direktorij za spletno stran je uspešno odstranjen.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetUporabniskihPodatkov()
    },
    ErrOdstraniDirektorij (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>
<style scoped src="./../../../../../static/css/Nastavitve/SpletnaPredstavitev/SpletnaPredstavitev.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/SpletnaPredstavitev.vue